export const copyTextUtil = (entryText: string): void => {
	void navigator.clipboard.writeText(entryText);
};
